// 新手導覽（GDO-22）的狀態：第一次造訪顯示，完成或略過後記在瀏覽器，不再自動出現。
import { type KeyValueStore, readJson, writeJson } from '../../storage/storage.ts';

export const TOUR_KEY = 'dayone:v1:onboarded';
/** 導覽內容有大幅改變時提高版本，讓使用者再看一次 */
export const TOUR_VERSION = 1;

export type TourStepKey = 'timeline' | 'filters' | 'detail' | 'install';
export const TOUR_STEPS: readonly TourStepKey[] = ['timeline', 'filters', 'detail', 'install'];

interface Stored {
  v: number;
  /** 'done' | 'skipped' */
  how: string;
  at: number;
}

export function shouldShowTour(store?: KeyValueStore | null): boolean {
  const s = readJson<Stored>(TOUR_KEY, store);
  return !s || typeof s.v !== 'number' || s.v < TOUR_VERSION;
}

export function markTourSeen(how: 'done' | 'skipped', now = Date.now(), store?: KeyValueStore | null): boolean {
  return writeJson(TOUR_KEY, { v: TOUR_VERSION, how, at: now } satisfies Stored, store);
}

/** 每一步要指向的元素（依序找第一個看得到的；手機與桌面的位置不同） */
export function tourTarget(step: TourStepKey, phone: boolean): string[] {
  switch (step) {
    case 'timeline':
      return ['.group-header', '.summary'];
    case 'filters':
      return ['.filters-toggle'];
    case 'detail':
      return ['article.card', '.summary'];
    case 'install':
      return phone ? ['.filters-toggle'] : ['.install-btn', '.rail-foot', '.filters-toggle'];
  }
}
